import type { FunctionComponent } from 'react';
import { useSearchLandingPageBySlugQuery } from '../../graphql/useSearchLandingPageBySlugQuery';
import { SearchLandingPageList } from './SearchLandingPageList';
import { PageContainer } from '../../../components/PageContainer';

export const SearchLandingPageListWithData: FunctionComponent = () => {
  const cachedQuery = useSearchLandingPageBySlugQuery();
  return !cachedQuery?.contentV2 ? null : (
    <PageContainer>
      <SearchLandingPageList content={cachedQuery.contentV2} />
    </PageContainer>
  );
};
